export default __webpack_public_path__ + "static/media/software-laboratorio.2c90dd5e.webp";